import React, { useCallback, useEffect, useState } from "react";
import { Table, Tooltip, Popover, Row } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { FaEye, FaLock, FaLockOpen, FaUserCircle } from "react-icons/fa";
import { MdDelete, MdEdit, MdPushPin } from "react-icons/md";
import { faEllipsisVertical } from "@fortawesome/free-solid-svg-icons";
import {
  faChevronLeft,
  faChevronRight,
  faAngleDoubleLeft,
  faAngleDoubleRight,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  TiArrowSortedDown,
  TiArrowSortedUp,
  TiArrowUnsorted,
} from "react-icons/ti";
import ReactPaginate from "react-js-pagination";
import dayjs from "dayjs";
import NoData from "../../../asserts/no data.png";
import ModalPopup from "../../Common/Modal/Modal";
import { DeleteContact, GetContactsData, UpdateContactFavorite, UpdateContactSensitive } from "../../../Api/SuperAdminVault/Contacts";

import ContactDelete from "./ContactDelete";
import ContactViewModal from "./ContactViewModal";
import ContactForm from "./ContactForm";
import { BsPinAngleFill } from "react-icons/bs";
import ContactOtpModal from "./ContactOtpModal";
import { IoMdShareAlt } from "react-icons/io";
import ShareModal from "../ShareModal";

const ITEMS_PER_PAGE = 10;

const priorityColor = (priority) => {
  switch (priority) {
    case "P1":
      return {
        bg: "bg-[#FD3434]",
        border: "border-[#FD3434]",
      };
    case "P2":
      return {
        bg: "bg-[#FF9900]",
        border: "border-[#FF9900]",
      };
    case "P3":
      return {
        bg: "bg-[#2A99FF]",
        border: "border-[#2A99FF]",
      };
    case "P4":
      return {
        bg: "bg-[#34AE2B]",
        border: "border-[#34AE2B]",
      };
    default:
      return {
        bg: "bg-[#646262]",
        border: "border-[#646262]",
      };
  }
};

const SortIcon = ({ order }) => {
  if (order === "ascend") {
    return (
      <Tooltip
        placement="top"
        title="Ascending"
        overlayStyle={{ pointerEvents: "none" }}
        color="white"
        overlayInnerStyle={{ color: "#1F487C" }}
      >
        <TiArrowSortedUp />
      </Tooltip>
    );
  }

  if (order === "descend") {
    return (
      <Tooltip
        placement="top"
        title="Descending"
        overlayStyle={{ pointerEvents: "none" }}
        color="white"
        overlayInnerStyle={{ color: "#1F487C" }}
      >
        <TiArrowSortedDown />
      </Tooltip>
    );
  }

  return (
    <Tooltip
      placement="top"
      title="Unsorted"
      overlayStyle={{ pointerEvents: "none" }}
      color="white"
      overlayInnerStyle={{ color: "#1F487C" }}
    >
      <TiArrowUnsorted />
    </Tooltip>
  );
};

const Contacts = ({
  searchValue,
  categoryFilter,
  refreshKey,
  openContactModal,
}) => {
  const dispatch = useDispatch();

  const contactsData = useSelector((state) => state.crm?.contacts_list || []);
  const pageContext = useSelector(
    (state) => state.crm?.contacts_page_context || {},
  );

  const [activePage, setActivePage] = useState(1);
  const [hoverId, setHoverId] = useState("");
  const [openPopovers, setOpenPopovers] = useState({});

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedContact, setSelectedContact] = useState(null);

  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [viewContact, setViewContact] = useState(null);

  const [localModalOpen, setLocalModalOpen] = useState(false);
  const [localModalMode, setLocalModalMode] = useState("add");
  const [localContactId, setLocalContactId] = useState(null);
  const [localRefreshKey, setLocalRefreshKey] = useState(0);

  const [sortedData, setSortedData] = useState([]);

  const [sortOrderName, setSortOrderName] = useState(null);
  const [sortOrderDesignation, setSortOrderDesignation] = useState(null);
  const [sortOrderOrganisation, setSortOrderOrganisation] = useState(null);
  const [sortOrderCategory, setSortOrderCategory] = useState(null);
  const [sortOrderPriority, setSortOrderPriority] = useState(null);
  const [sortOrderDate, setSortOrderDate] = useState(null);
  const [otpModalOpen, setOtpModalOpen] = useState(false);
  const [otpContact, setOtpContact] = useState(null);
  const [actionType,setActionType]=useState("");
  const[shareModelOpen,setShareModalOpen]=useState(false)
  const[shareContactId,setShareContactId]=useState("")
  const[sharedata,setSharedata]=useState()
  const[shareSensitive,setShareSensitive]=useState(false)


  const currentData = sortedData.length > 0 ? sortedData : contactsData;

  const fetchData = useCallback(
    (page = 1) => {
      GetContactsData({
        dispatch,
        page,
        limit: ITEMS_PER_PAGE,
        search: searchValue,
        filter_category: categoryFilter,
        sort_order: "A",
        sort_column: "contact_id",
      });
    },
    [dispatch, searchValue, categoryFilter],
  );

  useEffect(() => {
    setActivePage(1);
    setSortedData([]);
    resetSort();
    fetchData(1);
  }, [searchValue, categoryFilter, refreshKey, localRefreshKey, fetchData]);

  const resetSort = () => {
    setSortOrderName(null);
    setSortOrderDesignation(null);
    setSortOrderOrganisation(null);
    setSortOrderCategory(null);
    setSortOrderPriority(null);
    setSortOrderDate(null);
  };

  const handlePageChange = (page) => {
    setActivePage(page);
    setSortedData([]);
    resetSort();
    fetchData(page);
  };

  const handlePopoverToggle = (contactId, visible) => {
    if (visible) {
      setOpenPopovers({ [contactId]: true });
    } else {
      setOpenPopovers({});
    }
  };

  const closePopover = (contactId) => {
    setOpenPopovers((prev) => ({
      ...prev,
      [contactId]: false,
    }));
  };

  const handleOpenContactModal = (mode, id = null) => {
    if (openContactModal) {
      openContactModal(mode, id);
      return;
    }

    setLocalModalMode(mode);
    setLocalContactId(id);
    setLocalModalOpen(true);
  };

  const closeLocalModal = () => {
    setLocalModalOpen(false);
    setLocalModalMode("add");
    setLocalContactId(null);
  };

  const handleLocalSuccess = () => {
    setLocalRefreshKey((prev) => prev + 1);
  };

  const handleToggleFavorite = async (row) => {
  console.log("contact pin clicked:", row?.contact_id);

  await UpdateContactFavorite(row, !row?.is_favorite);

  fetchData(activePage);
};

const handleToggleSensitive = async (row) => {
  const nextStatus = !Boolean(row?.is_sensitive);
  if (nextStatus === true) {
    const response = await UpdateContactSensitive(row, true);

    if (response) {
      fetchData(activePage);
    }

    return;
  }
  const response = await UpdateContactSensitive(row, false);

  if (!response) return;

  const isOtpSent =
    response?.message?.toLowerCase()?.includes("otp") ||
    response?.message?.toLowerCase() === "otp send successfully";

  if (isOtpSent) {
    setOtpContact(row);
    setActionType("contact_status");
    setOtpModalOpen(true);
    return;
  }

  fetchData(activePage);
};

const handleDeleteClick = async (row) => {
  setSelectedContact(row);

  // Non-sensitive contact: normal delete modal
  if (!row?.is_sensitive) {
    setDeleteModalOpen(true);
    return;
  }

  // Sensitive contact: send OTP only, do not refresh table
  const response = await DeleteContact(row.contact_id, null, {}, false);

  if (!response) return;

  const isOtpSent =
    response?.message?.toLowerCase()?.includes("otp") ||
    response?.message?.toLowerCase() === "otp send successfully";

  if (isOtpSent) {
    setOtpContact(row);
    setActionType("delete_contact");
    setOtpModalOpen(true);
  }
};
  const sortByString = (key, order, setOrder) => {
    resetSort();

    let sorted = [...contactsData];

    if (order === "ascend") {
      sorted.sort((a, b) => (b[key] || "").localeCompare(a[key] || ""));
      setOrder("descend");
    } else if (order === "descend") {
      sorted = [...contactsData];
      setOrder(null);
    } else {
      sorted.sort((a, b) => (a[key] || "").localeCompare(b[key] || ""));
      setOrder("ascend");
    }

    setSortedData(sorted);
  };

  const handleDateSort = () => {
    resetSort();

    let sorted = [...contactsData];

    if (sortOrderDate === "ascend") {
      sorted.sort(
        (a, b) => dayjs(b.updated_at).valueOf() - dayjs(a.updated_at).valueOf(),
      );
      setSortOrderDate("descend");
    } else if (sortOrderDate === "descend") {
      sorted = [...contactsData];
      setSortOrderDate(null);
    } else {
      sorted.sort(
        (a, b) => dayjs(a.updated_at).valueOf() - dayjs(b.updated_at).valueOf(),
      );
      setSortOrderDate("ascend");
    }

    setSortedData(sorted);
  };

  const renderNoData = () => (
    <div className="grid grid-cols-1 mt-[15vw]">
      <div className="col-span-1 flex items-center justify-center text-gray-500">
        <img src={NoData} className="w-[3.5vw] h-[3.5vw]" alt="no data" />
      </div>

      <div className="col-span-1 flex items-center justify-center font-medium text-[2vw] mt-[0.5vw] text-gray-500">
        No Data Found
      </div>
    </div>
  );

  const columns = [
    {
      title: (
        <h1 className="text-[1.1vw] font-bold flex items-center justify-center">
          S.No
        </h1>
      ),
      width: "4vw",
      render: (_, __, index) => {
        const serial = (activePage - 1) * ITEMS_PER_PAGE + (index + 1);
        return (
          <h1 className="flex justify-center font-bold items-center text-[1vw] text-[#1F487C]">
            {serial}
          </h1>
        );
      },
    },
    {
      title: (
        <h1 className="text-[1.1vw] font-bold flex items-center justify-evenly">
          Name
        </h1>
      ),
      width: "16vw",
      render: (row) => (
        <div className="flex items-center justify-center">
          {row?.contact_name?.length > 15 ? (
            <Tooltip
              placement="top"
              title={row.contact_name}
              color="white"
              overlayInnerStyle={{ color: "#1F487C" }}
            >
              <p className="text-[1vw] font-bold text-[#1F487C] cursor-pointer">
                {`${row.contact_name.slice(0, 15)}...`}
              </p>
            </Tooltip>
          ) : (
            <p className="text-[1vw] font-bold text-[#1F487C]">
              {row.contact_name || "-"}
            </p>
          )}
        </div>
      ),
    },
    {
      title: (
        <h1 className="text-[1.1vw] font-bold flex items-center justify-evenly">
          Designation
        </h1>
      ),
      width: "14vw",
      render: (row) => (
        <p className="text-[1vw] text-[#1F487C] flex justify-center">
          {row.designation || "-"}
        </p>
      ),
    },
    {
      title: (
        <h1 className="text-[1.1vw] font-bold flex items-center justify-evenly">
          Organisation
        </h1>
      ),
      width: "15vw",
      render: (row) => (
        <p className="text-[1vw] text-[#1F487C] flex justify-center">
          {row.organisation || "-"}
        </p>
      ),
    },
    {
      title: (
        <h1 className="text-[1.1vw] font-bold flex items-center justify-evenly">
          Category
        </h1>
      ),
      width: "14vw",
      render: (row) => (
        <p className="text-[1vw] font-bold text-[#1F487C] flex justify-center">
          {row.category || "-"}
        </p>
      ),
    },
    {
      title: (
        <h1 className="text-[1.1vw] font-bold flex items-center justify-evenly">
          Priority
        </h1>
      ),
      width: "10vw",
      render: (row) => {
        const { bg, border } = priorityColor(row.priority);

        return (
          <div className="flex items-center justify-center">
            <div className={`border-[0.1vw] ${border} rounded-[0.5vw]`}>
              <div
                className={`${bg} border-dashed text-[1vw] font-bold border-white border-[0.2vw] rounded-[0.5vw] text-white w-[6vw] flex items-center justify-center`}
              >
                {row.priority || "-"}
              </div>
            </div>
          </div>
        );
      },
    },
    {
      title: (
        <h1 className="text-[1.1vw] font-bold flex items-center justify-evenly">
          Updated Date
          <button onClick={handleDateSort}>
            <SortIcon order={sortOrderDate} />
          </button>
        </h1>
      ),
      width: "13vw",
      render: (row) => (
        <p className="text-[1vw] text-[#1F487C] flex justify-center">
          {row.updated_at ? dayjs(row.updated_at).format("DD MMM, YY") : "-"}
        </p>
      ),
    },
    {
      title: (
        <h1 className="text-[1.1vw] font-bold text-center flex items-center justify-center">
          Actions
        </h1>
      ),
      width: "17vw",
      render: (row) => (
        <div className="grid grid-cols-6 gap-[0.35vw] items-center justify-center px-[1vw]">
          <Tooltip title="View" color="white" overlayInnerStyle={{ color: "#1F487C" }}>             
          <FaEye
            size={"1.3vw"}
            color="#1F4B7F"
            className="cursor-pointer"
            onClick={() => {
              setViewContact(row);
              setViewModalOpen(true);
            }}
          />
          </Tooltip>
      <Tooltip title="Edit" color="white" overlayInnerStyle={{ color: "#1F487C" }}>        
          <MdEdit
            size={"1.3vw"}
            color="#1F4B7F"
            className="cursor-pointer"
            onClick={() => {
              setActionType("update_contact")
              handleOpenContactModal("edit", row.contact_id)}
            }
          />
        </Tooltip>
     <Tooltip title="Delete" color="white" overlayInnerStyle={{ color: "#1F487C" }}>
        <MdDelete
  size={"1.3vw"}
  color="#1F4B7F"
  className="cursor-pointer"
  onClick={() => handleDeleteClick(row)}
/>
          </Tooltip>
                   <Tooltip
                     title={row?.is_favorite ? "Unpin" : "Pin"}
                     color="white"
                     overlayInnerStyle={{ color: "#1F487C" }}
                   >
                    {row?.is_favorite ? (
           <BsPinAngleFill
             size="1.25vw"
             color="#1F4B7F"
                         className="cursor-pointer"
                         onClick={() => handleToggleFavorite(row)}
                       />
                     ) : (
                       <BsPinAngleFill
                         size="1.25vw"
               color="#9CA3AF"   
                         className="cursor-pointer"
                         onClick={() => handleToggleFavorite(row)}
                       />
                     )}
                   </Tooltip>
                   <Tooltip
            title={row?.is_sensitive ? "Unlock" : "Lock"}
            color="white"
            overlayInnerStyle={{ color: "#1F487C" }}
          >
            {row?.is_sensitive ? (
  <FaLock
    size="1.1vw"
    color="#1F4B7F"
    className="cursor-pointer"
    onClick={() => handleToggleSensitive(row)}
  />
) : (
  <FaLockOpen
    size="1.1vw"
    color="#9CA3AF"
    className="cursor-pointer"
    onClick={() => handleToggleSensitive(row)}
  />
)}
          </Tooltip>
          <Tooltip title="Share" color="white" overlayInnerStyle={{ color: "#1F487C" }}>             
          <IoMdShareAlt
            size={"1.3vw"}
            color="#1F4B7F"
            className="cursor-pointer"
            onClick={() => {
            setShareModalOpen(true)
            setShareContactId(row?.contact_id)
            setSharedata(row)
            setShareSensitive(row?.is_sensitive)
            }}
          />
          </Tooltip>
        </div>
      ),
    },
  ];

  const renderGrid = () => {
    if (!currentData || currentData.length === 0) {
      return renderNoData();
    }

    return (
      <div className="pt-[0.5vw]">
        <div className="grid grid-cols-5 w-full gap-x-[4vw] gap-[0.75vw]">
          {currentData.map((item) => {
            const { bg, border } = priorityColor(item.priority);

            return (
              <div
                key={item.contact_id}
                className="bg-white text-[#1f4b7f] h-[16vw] relative border-[#1f4b7f] border-l-[0.1vw] cursor-default border-r-[0.3vw] border-b-[0.3vw] border-t-[0.1vw] rounded-[0.5vw]"
                onMouseEnter={() => setHoverId(item.contact_id)}
                onMouseLeave={() => setHoverId("")}
                style={{
                  transition: "ease-in 0.2s",
                  boxShadow:
                    hoverId === item.contact_id
                      ? "0.5vw 0.5vw 0.5vw #1f4b7f"
                      : "none",
                }}
              >
                <div className="flex justify-end pt-[1vw] pr-[0.5vw]">
                  <Popover
                    placement="bottomRight"
                    content={
                      <div className="flex flex-col border-[0.1vw] border-[#1F487C] rounded-[0.5vw] px-[0.5vw]">
                        <div
                          className="flex items-center gap-x-[0.5vw] py-[0.25vw] border-b-[0.1vw] border-[#1F487C] cursor-pointer"
                        onClick={() => {
  handleDeleteClick(item);
  closePopover(item.contact_id);
}}
                        >
                          <FaEye size={"1.1vw"} color="#1F4B7F" />
                          <a className="flex font-semibold items-center text-[1vw] text-[#1F4B7F] hover:text-[#1f487c]">
                            View
                          </a>
                        </div>

                        <div
                          className="flex items-center gap-x-[0.5vw] py-[0.25vw] border-b-[0.1vw] border-[#1F487C] cursor-pointer"
                          onClick={() => {
                            handleOpenContactModal("edit", item.contact_id);
                            closePopover(item.contact_id);
                          }}
                        >
                          <MdEdit size={"1.2vw"} color="#1F4B7F" />
                          <a className="flex font-semibold items-center text-[1vw] text-[#1F4B7F] hover:text-[#1f487c]">
                            Edit
                          </a>
                        </div>

                        <div
                          className="flex items-center gap-x-[0.5vw] py-[0.25vw] cursor-pointer"
                          onClick={() => {
                            setSelectedContact(item);
                            setDeleteModalOpen(true);
                            closePopover(item.contact_id);
                          }}
                        >
                          <MdDelete size={"1.2vw"} color="#1F4B7F" />
                          <a className="flex font-semibold items-center text-[1vw] text-[#1F4B7F] hover:text-[#1f487c]">
                            Delete
                          </a>
                        </div>
                      </div>
                    }
                    trigger="click"
                    open={openPopovers[item.contact_id] || false}
                    onOpenChange={(visible) =>
                      handlePopoverToggle(item.contact_id, visible)
                    }
                  >
                    <FontAwesomeIcon
                      icon={faEllipsisVertical}
                      color="#1f487c"
                      className="absolute right-[0.2vw] top-[0.8vw] cursor-pointer rounded-[0.5vw]"
                      style={{
                        height: "1.5vw",
                        width: "1.5vw",
                      }}
                    />
                  </Popover>
                </div>

                <div className="flex-col flex items-center h-full w-full gap-y-[0.1vw] px-[0.7vw]">
                  <div className="flex flex-col items-center justify-center w-auto px-[1vw] h-[4.8vw]">
                    <FaUserCircle size={"3.5vw"} color="#A9A9A9" />
                  </div>

                  <div className="flex flex-col w-full items-center justify-center gap-y-[0.25vw] mt-[0.1vw]">
                    <div className="font-bold text-[0.9vw] text-center max-w-full">
                      {item?.contact_name?.length > 18 ? (
                        <Tooltip
                          placement="top"
                          title={item.contact_name}
                          color="white"
                          overlayInnerStyle={{ color: "#1F487C" }}
                        >
                          <span className="cursor-pointer">
                            {`${item.contact_name.slice(0, 18)}...`}
                          </span>
                        </Tooltip>
                      ) : (
                        item.contact_name || "-"
                      )}
                    </div>

                    <div className="text-[0.9vw] flex">
                      <span className="font-semibold pr-[0.5vw]">
                        Designation:
                      </span>
                      <span>{item.designation || "-"}</span>
                    </div>

                    <div className="text-[0.9vw] flex">
                      <span className="font-semibold pr-[0.5vw]">
                        Category:
                      </span>
                      <span>{item.category || "-"}</span>
                    </div>

                    <div className="text-[0.9vw] flex">
                      <span className="font-semibold pr-[0.5vw]">Phone:</span>
                      <span>{item.phone || "-"}</span>
                    </div>

                    <div className="px-[0.7vw] w-full">
                      <div className={`${border} border-[0.1vw] rounded-full`}>
                        <div
                          className={`${bg} border-dashed border-white border-[0.2vw] text-[1.1vw] rounded-full text-white py-[0.2vw] w-full flex items-center justify-center`}
                        >
                          {item.priority || "-"}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="h-[72vh] w-full">
        <Table
          dataSource={currentData}
          columns={columns}
          rowKey="contact_id"
          pagination={false}
          className="custom-table"
        />
      </div>

      {pageContext?.total > ITEMS_PER_PAGE && (
        <div className="w-full h-[8vh] flex justify-between items-center">
          <div className="text-[#1F487C] flex text-[1.1vw] gap-[0.5vw]">
            <span>Showing</span>
            <span className="font-bold">
              {currentData && currentData.length > 0 ? (
                <div>
                  {(activePage - 1) * ITEMS_PER_PAGE + 1} -{" "}
                  {(activePage - 1) * ITEMS_PER_PAGE + currentData.length}
                </div>
              ) : (
                "0"
              )}
            </span>
            <span>from</span>
            <span className="font-bold">{pageContext?.total || 0}</span>
            <span>data</span>
          </div>

          <ReactPaginate
            activePage={activePage}
            itemsCountPerPage={ITEMS_PER_PAGE}
            totalItemsCount={pageContext?.total || 0}
            pageRangeDisplayed={3}
            onChange={handlePageChange}
            itemClass="page-item"
            linkClass="page-link"
            activeClass="active"
            prevPageText={<FontAwesomeIcon icon={faChevronLeft} size="1vw" />}
            nextPageText={<FontAwesomeIcon icon={faChevronRight} size="1vw" />}
            firstPageText={
              <FontAwesomeIcon icon={faAngleDoubleLeft} size="1vw" />
            }
            lastPageText={
              <FontAwesomeIcon icon={faAngleDoubleRight} size="1vw" />
            }
          />
        </div>
      )}

      <ModalPopup
        show={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
        height="20vw"
        width="30vw"
        closeicon={false}
      >
        <ContactDelete
          setDeleteModalIsOpen={setDeleteModalOpen}
          content={"Want to delete this"}
          title={selectedContact?.contact_name}
          contactId={selectedContact?.contact_id}
          filter={{
            page: activePage,
            limit: ITEMS_PER_PAGE,
            filter_category: categoryFilter,
            search: searchValue,
            sort_order: "A",
            sort_column: "contact_id",
          }}
        />
      </ModalPopup>

      <ContactViewModal
        open={viewModalOpen}
        onClose={() => {
          setViewModalOpen(false);
          setViewContact(null);
        }}
        contact={viewContact}
      />

      {!openContactModal && (
        <ModalPopup
          show={localModalOpen}
          onClose={closeLocalModal}
          height="35vw"
          width="50vw"
          closeicon={false}
        >
          <ContactForm
            contactId={localContactId}
            mode={localModalMode}
            setModalIsOpen={setLocalModalOpen}
            onSuccess={handleLocalSuccess}
            currentFilter={categoryFilter}
          />
        </ModalPopup>
      )}
      <ContactOtpModal
  show={otpModalOpen}
  onClose={() => {
    setOtpModalOpen(false);
    setOtpContact(null);
    setActionType("");
  }}
  onVerified={() => {
    setOtpModalOpen(false);
    setOtpContact(null);
    setActionType("");
    fetchData(activePage);
  }}
  contactId={otpContact?.contact_id}
  payload={
  actionType === "contact_status"
    ? { contact: otpContact, status: false }
    : {}
}
  actionType={actionType}
/>
<ShareModal
show={shareModelOpen}
onClose={() => {
setShareModalOpen(false)
  }}
  module="contacts"
  previewContent={
    <div className="">
      <div className="flex gap-1">
        <p className="font-semibold">Name:</p>
        <p>{sharedata?.contact_name || "-"}</p>
      </div>
      <div className="flex gap-1">
        <p className="font-semibold">Email:</p>
        <p>{sharedata?.email || "-"}</p>
      </div>

      <div className="flex gap-1">
        <p className="font-semibold">Phone:</p>
        <p>{sharedata?.phone || "-"}</p>
      </div>

    </div>
  }
  id={shareContactId}
  isSens={shareSensitive}
/>
    </>
  );
};

export default Contacts;
